import $api from "../http";
import { IUserNote, IUserNoteModel, IUserNotesPage } from "../models/UserNote";

class UserNoteServiceClass {
  // Newest first; without a cursor - the first page
  getPage(userId: string, cursor: string | null) {
    return $api.get<IUserNotesPage>(`api/users/${userId}/notes`, {
      params: cursor ? { cursor } : undefined,
    });
  }

  create(userId: string, model: IUserNoteModel) {
    return $api.post<IUserNote>(`api/users/${userId}/notes`, model);
  }

  update(userId: string, id: string, model: IUserNoteModel) {
    return $api.put<IUserNote>(`api/users/${userId}/notes/${id}`, model);
  }

  delete(userId: string, id: string) {
    return $api.delete<{}>(`api/users/${userId}/notes/${id}`);
  }
}

export const UserNoteService = new UserNoteServiceClass();
